import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["SocialShare","RelatedPosts","MoreArticles"] */ "/vercel/path0/src/app/blog/[slug]/BlogClientComponents.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/blog/[slug]/mdx-styles.css");
